import { publicClient, privateClient } from "../../configs/axiosConfig";

const staffEndpoints = {
  createStaff: "v2/staff",
  getAllStaffs: "v2/staff",
  getStaffInfo: "v2/staff/:id",
  updateStaff: "v2/staff/:id",

  deleteStaff: "v2/staff/delete/:id",
};

const staffApi = {
  create: async (values) => {
    try {
      const response = await privateClient.post(
        staffEndpoints.createStaff,
        values
      );

      return { response };
    } catch (err) {
      console.log("err Dr. Man Ha Sign in API");
      return { err };
    }
  },
  getAllStaffInfo: async () => {
    try {
      const response = await privateClient.get(staffEndpoints.getAllStaffs);

      return { response };
    } catch (err) {
      return { err };
    }
  },
  getStaffInfo: async (id) => {
    try {
      const url = staffEndpoints.getStaffInfo.replace(":id", id);

      const response = await privateClient.get(url);

      return { response };
    } catch (err) {
      return { err };
    }
  },

  updateStaff: async (id, data) => {
    try {
      const endpoint = staffEndpoints.updateStaff.replace(":id", id);
      const response = await privateClient.put(endpoint, data);
      return { response };
    } catch (err) {
      return { err };
    }
  },

  updateProfile: async (data) => {
    try {
      const response = await privateClient.put(
        staffEndpoints.updateProfile,
        data
      );
      return response;
    } catch (err) {
      throw new Error(err.response?.data?.message || "Profile update failed");
    }
  },
  passwordUpdate: async ({ password, newPassword, confirmNewPassword }) => {
    try {
      const response = await privateClient.put(staffEndpoints.passwordUpdate, {
        password,
        newPassword,
        confirmNewPassword,
      });

      return { response };
    } catch (err) {
      return { err };
    }
  },
  //delete staff
  deleteStaff: async (id) => {
    try {
      const url = staffEndpoints.deleteStaff.replace(":id", id);
      const response = await privateClient.post(url);
      return { response };
    } catch (err) {
      return { err };
    }
  },
};

export default staffApi;
